import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { X_EXCLUDE_BASE_URL, X_SKIP_ALERT } from 'src/app/core/constants/http-headers';

@Injectable({
  providedIn: 'root'
})
export class ConnectionCheckService {
  constructor(private http: HttpClient) {}

  hasInternetConnection(): Observable<boolean> {
    return this.http
      .get('/connection-check', {
        observe: 'response',
        headers: {
          [X_SKIP_ALERT]: '1',
          [X_EXCLUDE_BASE_URL]: '1'
        },
        params: {
          t: Date.now() // Timestamp for cache busting
        }
      })
      .pipe(
        map((response) => {
          return response.ok;
        }),
        catchError(() => {
          return of(false);
        })
      );
  }
}
